import { render } from "./SmallCircledExclamationIcon.vue?vue&type=template&id=e5f984e2&scoped=true"
import script from "./SmallCircledExclamationIcon.vue?vue&type=script&lang=js"
export * from "./SmallCircledExclamationIcon.vue?vue&type=script&lang=js"

import "./SmallCircledExclamationIcon.vue?vue&type=style&index=0&id=e5f984e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e5f984e2"

export default script